<template>
  <div class="dashboard">
    <Sidebar :open="isSidebarExpanded" @toggle="handleSidebarToggle" />

    <div class="content-row">
      <div
        class="sidebar-spacer"
        :style="{ width: isSidebarExpanded ? '250px' : '60px' }"
      ></div>
    </div>

    <div class="main-content">
      <header>
        <div class="header-left">
          <i class="fas fa-bars" @click="handleSidebarToggle"></i>
          <WaitingDriversNumber :waiting-captains="waitingCaptains" />
        </div>
      </header>

      <div class="users-list">
        <div class="users-header">
          <h2>Notifications</h2>
        </div>

        <div class="card">
          <form @submit.prevent="sendNotification">
            <div class="grid">
              <!-- نوع الإرسال -->
              <div class="field">
                <label>النوع</label>
                <select v-model="form.type" required>
                  <option disabled value="">اختر النوع</option>
                  <option value="driver">Driver</option>
                  <option value="user">User</option>
                </select>
              </div>

              <!-- Recipient ID -->
              <div class="field">
                <label>Recipient ID</label>
                <input
                  type="text"
                  placeholder="مثال: 685fbc496836ec69df8c8274"
                  v-model.trim="form.id"
                  :disabled="form.sendToAll || form.sendByRegion"
                />
              </div>

              <!-- التشيك بوكسات في صف واحد -->
              <div class="field checkbox-row">
                <label class="checkbox-inline">
                  <input type="checkbox" v-model="form.sendToAll" />
                  <span>إرسال إلى الكل</span>
                </label>
              </div>

              <div class="field checkbox-row">
                <label class="checkbox-inline">
                  <input type="checkbox" v-model="form.sendByRegion" />
                  <span>إرسال حسب المنطقة</span>
                </label>
              </div>

              <!-- اختيار المنطقة -->
              <div class="field col-span-2" v-if="form.sendByRegion">
                <label>اختر المنطقة</label>
                <select v-model="form.regionName">
                  <option disabled value="">اختر المنطقة</option>
                  <option v-for="r in regions" :key="r" :value="r">
                    {{ r }}
                  </option>
                </select>
              </div>

              <!-- نص الإشعار -->
              <div class="field col-span-2">
                <label>نص الإشعار</label>
                <textarea
                  v-model.trim="form.notificationMessage"
                  rows="5"
                  placeholder="اكتب نص الرسالة هنا..."
                  required
                  @input="charCount = form.notificationMessage.length"
                />
                <div class="muted">عدد الأحرف: {{ charCount }}</div>
              </div>

              <!-- الأزرار -->
              <div class="actions col-span-2">
                <button type="submit" :disabled="loading">
                  {{ loading ? "جاري الإرسال..." : "إرسال الإشعار" }}
                </button>

                <button
                  type="button"
                  class="secondary"
                  @click="resetForm"
                  :disabled="loading"
                >
                  تفريغ الحقول
                </button>
              </div>
            </div>
          </form>

          <div v-if="feedback.message" class="toast" :class="feedback.type">
            {{ feedback.message }}
          </div>
        </div>

        <!-- سجل الإرسال -->
        <div class="card">
          <h3>آخر عمليات الإرسال</h3>
          <div v-if="history.length === 0" class="muted">
            لا يوجد عمليات بعد.
          </div>

          <table v-else class="table">
            <thead>
              <tr>
                <th>التوقيت</th>
                <th>النوع</th>
                <th>المستلم</th>
                <th>النص</th>
                <th>النتيجة</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(h, i) in history" :key="i">
                <td>{{ h.time }}</td>
                <td>{{ h.type }}</td>
                <td>{{ h.id }}</td>
                <td class="wrap">{{ h.message }}</td>
                <td :class="h.ok ? 'ok' : 'err'">
                  {{ h.ok ? "Success" : "Error" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import Sidebar from "./sidebarComponent.vue";
import WaitingDriversNumber from "@/components/waitingDriversNumber.vue";

export default {
  name: "NotificationCenter",
  components: { Sidebar, WaitingDriversNumber },

  data() {
    return {
      isSidebarExpanded: true,
      waitingCaptains: 0,

      API_URL: "https://backend.fego-rides.com/admin/adminSendNotification",

      loading: false,
      charCount: 0,

      form: {
        type: "",
        sendToAll: false,
        sendByRegion: false,
        id: "",
        regionName: "",
        notificationMessage: "",
      },

      feedback: { message: "", type: "info" },
      history: [],
      regions: [],
    };
  },

  methods: {
    handleSidebarToggle() {
      this.isSidebarExpanded = !this.isSidebarExpanded;
    },

    resetForm() {
      this.form = {
        type: "",
        sendToAll: false,
        sendByRegion: false,
        id: "",
        regionName: "",
        notificationMessage: "",
      };
      this.charCount = 0;
      this.feedback = { message: "", type: "info" };
    },

    buildHeaders() {
      const token =
        localStorage.getItem("admin_token") ||
        localStorage.getItem("token") ||
        "";
      return {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      };
    },

    validate() {
      if (!this.form.type) {
        this.toast("من فضلك اختر النوع.", "error");
        return false;
      }

      if (!this.form.sendToAll && !this.form.sendByRegion && !this.form.id) {
        this.toast("لو مش هتبعت للكل أو لمنطقة لازم تدخل ID.", "error");
        return false;
      }

      if (this.form.sendByRegion && !this.form.regionName) {
        this.toast("اختر المنطقة.", "error");
        return false;
      }

      if (!this.form.notificationMessage) {
        this.toast("الرسالة مطلوبة.", "error");
        return false;
      }

      return true;
    },

    async fetchRegions() {
      try {
        const res = await axios.get(
          "https://backend.fego-rides.com/active-region/all",
          { headers: this.buildHeaders() }
        );

        const list = res.data.map((r) => r.regionName).filter(Boolean);
        this.regions = [...new Set(list)];
      } catch (err) {
        console.error("Error loading regions:", err);
      }
    },

    toast(message, type = "info") {
      this.feedback = { message, type };
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(
        () => (this.feedback = { message: "", type: "info" }),
        4000
      );
    },

    async sendNotification() {
      if (!this.validate()) return;

      const isBroadcast = this.form.sendToAll || this.form.sendByRegion;

      const payload = {
        id: isBroadcast ? "all" : this.form.id,
        notificationMessage: this.form.notificationMessage,
        type: this.form.type,
        regionName: this.form.sendByRegion ? this.form.regionName : null,
      };

      this.loading = true;
      this.toast("جارٍ إرسال الإشعار...", "info");

      try {
        await axios.post(this.API_URL, payload, {
          headers: this.buildHeaders(),
        });
        this.toast("تم الإرسال بنجاح", "success");

        this.history.unshift({
          time: new Date().toLocaleString(),
          ...payload,
          ok: true,
        });

        this.history = this.history.slice(0, 10);
      } catch (err) {
        this.toast("خطأ أثناء الإرسال", "error");
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.fetchRegions(); // ← مهمة جدًا
  },
};
</script>

<style scoped>
:root {
  --sidebar-width: 250px; /* نفس عرض السايدبار في Sidebar.vue */
  --sidebar-collapsed: 60px; /* عرضه وهو مقفول (أيقونات) */
}

/* ====== Layout الأساسي للداشبورد ====== */
.dashboard {
  display: block;
}

/* صف السبيسر + المحتوى */
.content-row {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

/* السبيسر بتاع السايدبار */
.sidebar-spacer {
  flex: 0 0 auto;
  transition: width 0.3s ease;
}

/* المحتوى الرئيسي في النص زي باقي الصفحات */
.main-content {
  flex: 1 1 auto;
  min-width: 0;
  padding: 16px;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

@media (max-width: 720px) {
  .sidebar-spacer {
    width: 0 !important;
  }
  .main-content {
    max-width: 100%;
    margin: 0;
  }
}

/* السايدبار (نفس الموجود فى الصفحات التانية) */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--sidebar-width);
  height: 100%;
  background: #2d2d2d;
  transition: width 0.3s ease;
  z-index: 1000;
}

.sidebar-collapsed {
  width: var(--sidebar-collapsed);
}

.main-content-expanded {
  margin-left: var(--sidebar-width);
}

header {
  position: relative;
  z-index: 1;
}

/* ====== كروت و فورم الإشعارات ====== */
.card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 16px;
  margin: 12px 0;
}

/* شبكه عمودين: النوع + الـ ID / التشيك بوكسين جنب بعض */
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.col-span-2 {
  grid-column: span 2;
}

.field label {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
}

.field select,
.field input,
.field textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 12px;
  box-sizing: border-box;
}

/* صف التشيك بوكس */
.checkbox-row {
  display: flex;
  align-items: center;
  margin-top: 24px; /* عشان يطلع في نفس مستوى السطر الأول تقريباً */
}

.checkbox-inline {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* أزرار في النص */
.actions {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 12px;
}

button {
  border: 0;
  padding: 10px 18px;
  border-radius: 10px;
  cursor: pointer;
  background: #965edb;
  color: #fff;
  font-weight: 600;
}

button.secondary {
  background: #e5e7eb;
  color: #111827;
}

/* توست الرسائل */
.toast {
  padding: 12px 14px;
  border-radius: 12px;
  margin: 12px 0;
  font-weight: 600;
}
.toast.info {
  background: #eff6ff;
  color: #1e40af;
}
.toast.success {
  background: #ecfdf5;
  color: #065f46;
}
.toast.error {
  background: #fef2f2;
  color: #991b1b;
}

/* جدول الهستوري */
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.table th,
.table td {
  border-bottom: 1px solid #f3f4f6;
  padding: 10px 8px;
  text-align: left;
  vertical-align: top;
}
.wrap {
  white-space: pre-wrap;
  word-break: break-word;
}
.ok {
  color: #065f46;
}
.err {
  color: #991b1b;
}

.muted {
  color: #6b7280;
  font-size: 13px;
}

/* موبايل */
@media (max-width: 720px) {
  .grid {
    grid-template-columns: 1fr;
  }
  header {
    position: relative;
    z-index: 1;
  }
}
</style>
